import { useState } from 'preact/hooks';
import Modal from './shared/Modal.jsx';
import Button from './shared/Button.jsx';

// `nextStep` staat aan bij een net geregistreerd product: dan is het token niet
// het einde van de rit maar de helft ervan, en zegt het scherm dat ook.
export default function TokenDisplayModal({ isOpen, token, productName, nextStep, onClose }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(token || '');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`API-token voor ${productName}`}>
      <div class="token-display">
        <p class="muted">
          Bewaar dit token nu — het wordt <strong>niet opnieuw getoond</strong>.
          Het product gebruikt dit token om zich bij 4U te identificeren.
        </p>
        <div class="token-box">
          <code>{token}</code>
        </div>
        {nextStep && (
          <p class="muted small">
            Hierna stel je de pakketten in. Zonder een verkoopbaar pakket kan
            {' '}{productName} niet worden verkocht en verschijnt het nergens.
          </p>
        )}
        <div class="form-actions">
          <Button variant="ghost" type="button" onClick={copy}>
            {copied ? 'Gekopieerd ✓' : 'Kopieer'}
          </Button>
          <Button type="button" onClick={onClose}>
            {nextStep ? 'Verder naar pakketten →' : 'Sluiten'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
